<template>
	<div class="adminhome">
		<div class="pageTitle">管理员审核</div>
		<div class="btnbox">
			<van-row gutter="15">
				<van-col span="8" @click="choiceBtn(1,'AdminArticleComment')"><div :class="btn_active==1?'adminbtn btn_active':'adminbtn'">文章评论</div></van-col>
				<van-col span="8" @click="choiceBtn(2,'AdminBbsComment')"><div :class="btn_active==2?'adminbtn btn_active':'adminbtn'">论坛评论</div></van-col>
				<van-col span="8" @click="choiceBtn(3,'AdminBbslist')"><div :class="btn_active==3?'adminbtn btn_active':'adminbtn'">帖子审核</div></van-col>
			</van-row>
			<van-row gutter="15">
				<van-col span="8"><div :class="btn_active==4?'adminbtn btn_active':'adminbtn'">视频审核</div></van-col>
				<van-col span="8"><div :class="btn_active==5?'adminbtn btn_active':'adminbtn'">头像审核</div></van-col>
				<van-col span="8"><div :class="btn_active==6?'adminbtn btn_active':'adminbtn'">昵称审核</div></van-col>
			</van-row>
			<van-row gutter="15">
				<van-col span="8"><div :class="btn_active==7?'adminbtn btn_active':'adminbtn'">车主认证审核</div></van-col>
				<van-col span="8"><div :class="btn_active==8?'adminbtn btn_active':'adminbtn'">活动申请审核</div></van-col>
				<van-col span="8"><div :class="btn_active==9?'adminbtn btn_active':'adminbtn'">大V认证审核</div></van-col>
			</van-row>
			<van-row gutter="15">
				<van-col span="8"><div :class="btn_active==10?'adminbtn btn_active':'adminbtn'">GUC投稿</div></van-col>
				<van-col span="8"><div :class="btn_active==11?'adminbtn btn_active':'adminbtn'">商城订单确认</div></van-col>
				<van-col span="8"><div :class="btn_active==12?'adminbtn btn_active':'adminbtn'">商城商品退货</div></van-col>
			</van-row>
		</div>
	</div>
</template>
<script>
	import admin from '../../api/admin';
	import { mapState } from 'vuex';
	import { Col, Row,Toast } from 'vant';
	export default {
		data () {
			return {
				btn_active:'',
				code:0
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user
			})
		},

		created () {
			if(this.$route.query.code){
				// Toast('created='+this.$route.query.code)
				this.getLogin(this.$route.query.code)
			}


		},
		methods: {
			choiceBtn(index,name){
				if(localStorage.getItem('adminToken')){
					this.token=true
					this.btn_active=index
					this.$router.push({name:name,params:{token:this.token,user_id:this.user_id,newtime:newTime}});

				}else{
					// var newTime=new Date()
					// var Year = newTime.getFullYear()
					// var Month = newTime.getMonth() + 1
					// var Day = newTime.getDate() 
					// var LoginTime=Year.toString()+Month.toString()+Day.toString()
					// localStorage.setItem('LoginTime', LoginTime)
					// var local=window.location.href
					// window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd8669654e2c13e60&redirect_uri='+encodeURIComponent(local)+'&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect&connect_redirect=1'
					this.$router.push({name:'AdminLogin'});
				}
			},
			getLogin(code){
				var params={
					code:code,
					source:1
				}
				admin.getLogin(params).then(res => {

					localStorage.setItem('userinfo', JSON.stringify(res.data.data.user))
					localStorage.setItem('adminToken', res.data.data.access_token)
					// Toast('登陆成功')
				})
			}
		},
		components: {
			[Col.name]: Col,
			[Row.name]: Row,
			[Toast.name]:Toast
		}
	}
</script>
<style lang="scss">
	.adminhome{
		.btnbox{
			padding:0 15px;
			.van-row{
				margin-top: 15px;
				.adminbtn{
					border: 1px solid #666666;
					font-size: 14px;
					color: #000;
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 13px 0;
					background-color:#fff;
				}
				.btn_active{
					background-color: #005DA3;
					border: 0px solid #666666;
					color: #fff;
				}
			}
		}
	}
</style>
